import { createReducer } from 'typesafe-actions'
import { setShouldNavigateToTarget } from '../actions/app/navigation.actions'
export const defaultState: boolean = false

const navigateToTargetReducer = createReducer(defaultState)
    .handleAction(setShouldNavigateToTarget, (state, action) => action.payload)

export default navigateToTargetReducer
